import { Button } from "PFComponents/button";
import DropDown from "PFComponents/dropdown/dropdown";
import { hideBackdrop, showBackdrop } from "PFCore/helpers/backdrop";
import PropTypes from "prop-types";
import React from "react";
class DropDownButton extends React.Component {
  state = {
    menuShown: false
  };

  hideMenu = () => {
    hideBackdrop({ id: "DropDownBackdrop" });

    this.setState({ menuShown: false });
  };

  handleMenuClick = () => {
    this.setState({ menuShown: true });

    showBackdrop({
      id: "DropDownBackdrop",
      onclick: this.hideMenu,
      style: { opacity: 0 }
    });
  };

  handleMenuChange = (item) => {
    const { handleChange } = this.props;

    handleChange && handleChange(item);

    this.hideMenu();
  };

  handleClose = () => {
    const { handleClose } = this.props;

    this.hideMenu();

    handleClose && handleClose();
  };

  render() {
    const { menuShown } = this.state;
    const { label, kind, size, disabled, rootClassName, qaId, options, buttonStyle, dropDownStyle } =
      this.props;

    const defaultStyle = {
      right: 0,
      top: 40,
      minWidth: 100,
      maxWidth: 200,
      ...dropDownStyle
    };

    return (
      <div style={{ position: "relative", display: "inline-block" }}>
        <Button
          style={buttonStyle}
          kind={kind}
          rootClassName={rootClassName}
          size={size}
          disabled={disabled}
          qaId={qaId}
          onClick={this.handleMenuClick}
        >
          {label}
          {this.props.children}
        </Button>
        {menuShown && (
          <DropDown
            style={defaultStyle}
            options={options}
            handleChange={this.handleMenuChange}
            handleClose={this.handleClose}
          />
        )}
      </div>
    );
  }
}

DropDownButton.propTypes = {
  ...Button.propTypes,
  ...DropDown.propTypes,
  label: PropTypes.node,
  dropDownStyle: PropTypes.object
};

DropDownButton.defaultProps = {
  ...Button.defaultProps,
  ...DropDown.defaultProps,
  label: null,
  dropDownStyle: null,
  handleClick: null
};

export default DropDownButton;
